export default "__VITE_ASSET__DMdJYqlN__"